export const SINGLE_REFRESH_BACKOFF_MS = [5000, 10000, 20000, 60000];

export const SINGLE_REFRESH_COALESCE_MS = 500;
export const SINGLE_REFRESH_COOLDOWN_MS = 3000;
export const SINGLE_REFRESH_TRAILING_QUIET_MS = 1500;

